import React from 'react';
import { WebsiteDesignProps } from './types';
import { Scissors, FileText, StickyNote } from 'lucide-react';
import { Button } from "@/components/ui/button";

const PaperCraft: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "The Collage School";

    return (
        <div className="bg-[#f3e5ab] min-h-screen font-serif text-[#3e2723] overflow-hidden">
            {/* Paper Texture Overlay */}
            <div className="fixed inset-0 pointer-events-none opacity-40 mix-blend-multiply flex flex-wrap" style={{backgroundImage: `url('https://www.transparenttextures.com/patterns/cream-paper.png')`}}></div>

            <nav className="p-8 relative z-20 flex justify-between items-center">
                 <div className="bg-white px-6 py-4 shadow-lg transform -rotate-2 border border-gray-200">
                     <h1 className="text-2xl font-bold tracking-wider uppercase text-gray-800">{schoolName}</h1>
                     <div className="h-4 w-4 rounded-full bg-red-400 absolute -top-2 -right-2 shadow-sm"></div>
                 </div>
                 <Button className="bg-[#2c3e50] text-white rounded-none shadow-md transform rotate-1 hover:rotate-0 transition-transform font-bold">
                     Apply Now <Scissors size={16} className="ml-2" />
                 </Button>
            </nav>

            <main className="container mx-auto px-6 py-12 relative z-10">
                <div className="flex flex-col md:flex-row items-center gap-12">
                    <div className="md:w-1/2 relative">
                        <div className="bg-blue-200 w-64 h-64 absolute top-0 right-10 transform rotate-12 shadow-md"></div>
                        <div className="bg-pink-200 w-64 h-64 absolute bottom-0 left-10 transform -rotate-6 shadow-md"></div>
                        <div className="bg-white p-4 pb-12 shadow-xl transform rotate-3 relative z-10 w-full max-w-md mx-auto">
                            <img src="https://images.unsplash.com/photo-1503676260728-1c00da094a0b?q=80&w=2022&auto=format&fit=crop" className="w-full grayscale contrast-125" alt="Kid" />
                            <div className="font-handwriting text-center mt-4 text-xl">"Learning is messy & fun!"</div>
                            <div className="w-32 h-8 bg-yellow-300 opacity-50 absolute bottom-10 left-10 transform -rotate-2"></div>
                        </div>
                    </div>
                    
                    <div className="md:w-1/2">
                        <div className="bg-white p-8 shadow-lg transform -rotate-1 relative mb-8">
                             <div className="w-4 h-4 rounded-full bg-gray-300 absolute top-4 left-1/2 -translate-x-1/2 shadow-inner"></div>
                             <h2 className="text-5xl font-bold mb-6 text-gray-900 leading-tight">
                                 Cut, Paste, <br/> & Create.
                             </h2>
                             <p className="text-xl leading-relaxed text-gray-700 font-medium">
                                 We believe in tactile learning. Our curriculum is hands-on, creative, and designed to build real-world problem solving skills.
                             </p>
                        </div>
                        
                        <div className="flex gap-6">
                            <div className="bg-yellow-100 p-4 shadow w-32 text-center transform rotate-3 hover:rotate-0 transition-transform cursor-pointer">
                                <StickyNote className="mx-auto mb-2 text-yellow-600" />
                                <span className="font-bold text-sm">Notes</span>
                            </div>
                            <div className="bg-green-100 p-4 shadow w-32 text-center transform -rotate-2 hover:rotate-0 transition-transform cursor-pointer">
                                <FileText className="mx-auto mb-2 text-green-600" />
                                <span className="font-bold text-sm">Essays</span>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default PaperCraft;
